
namespace TabAurous.Stock {

    import fld = StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class JewelleryStockGrid extends _Ext.GridBase<StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.StockItem'; } 
        protected getIdProperty() { return StockItemRow.idProperty; }
        protected getInsertPermission() { return StockItemRow.insertPermission; }
        protected getLocalTextPrefix() { return StockItemRow.localTextPrefix; }
        protected getService() { return JewelleryService.baseUrl; }
        protected getInitialTitle() { return null; };
        private autoSize; 
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        }; 
        constructor(container: JQuery, options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }
        get selectedItems(): StockItemRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }      
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }        
        protected getViewOptions() {
            var opt = super.getViewOptions();            
            opt.rowsPerPage = 100;
            return opt;
        }



    }
}